import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Component, Input, OnInit } from '@angular/core';
import { CustomerService } from '@proximus/ng-common';
import { isB2B2ECustomer, SimInfoResource } from '@dch/products-business-logic';

@Component({
  selector: 'mprd-sim-and-puk',
  templateUrl: './sim-and-puk.component.html',
})
export class SimAndPukComponent implements OnInit {
  @Input()
  simInfo: SimInfoResource;

  isPending: boolean;
  hideSimCode = true;
  hidePukCode = true;
  isB2b2e$: Observable<boolean> | undefined;

  constructor(private customerService: CustomerService) {}

  ngOnInit(): void {
    this.isB2b2e$ = this.customerService
      .getCustomerAccount()
      .pipe(map((user) => Boolean(isB2B2ECustomer(user))));
  }

  toggleSimCode() {
    this.hideSimCode = !this.hideSimCode;
  }

  togglePukCode() {
    this.hidePukCode = !this.hidePukCode;
  }
}
